import type { MeResponse, PlatformMeResponse } from '@testpio/shared';
import { useQuery } from '@tanstack/react-query';
import { ApiError, http } from './api';

export const ME_KEY = ['me'] as const;
export const PLATFORM_ME_KEY = ['platform-me'] as const;
const LAST_INSTITUTE_KEY = 'ur:institute';

/** The signed-in institute user, or null. */
export function useMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await http.get<MeResponse>('/auth/me');
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export function usePlatformMe() {
  return useQuery({
    queryKey: PLATFORM_ME_KEY,
    queryFn: async () => {
      try {
        return await http.get<PlatformMeResponse>('/platform/me');
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
  });
}

export function rememberInstitute(code: string): void {
  try {
    localStorage.setItem(LAST_INSTITUTE_KEY, code);
  } catch {
    // storage unavailable
  }
}

export function lastInstitute(): string | null {
  try {
    return localStorage.getItem(LAST_INSTITUTE_KEY);
  } catch {
    return null;
  }
}

export function homePathFor(role: string): string {
  return role === 'student' ? '/s' : '/app';
}
